function getCreateGeocodeLink({ id }: { id: string }) {
  return `/address-geocoder/create/${id}`
}

export { getCreateGeocodeLink }
